<template>
  <ul v-if="attach" :class="className">
    <li
      v-for="(value, index) in attaInfo"
      :key="index"
      class="active"
      @click="openDownload(value.url)"
    >
      <div
        :class="{ vip_sib: GetMyInfo.info.vip }"
        @click="openDownload(value.url)"
      >
        <span
          ><img
            :src="`../../mobile/img/icon_${fileImg(value.name)}.png`"
            alt=""
        /></span>
        <div>
          <!-- <a :href="value.url" download> -->
          <p>{{ value.name }}</p>
          <em v-if="value.size">({{ value.size }})</em>
          <!-- </a> -->
        </div>
      </div>
      <span
        :class="{ vip: GetMyInfo.info.vip }"
        @click="openDownload(value.url, true)"
      ></span>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["attaInfo", "attach", "className"],
  created(){
  },
  computed: {
    ...mapGetters("mainjs", ["GetMyInfo"]),
  },
  methods: {
    openDownload(url) {
      var goto = `/mobile_index/viewer`;
      var setToken = this.replaceAll(this.getToKen(), "+", "$SIS$");
      if (this.isApp()) {
        location.href = `m60call://browser?urladdress=${goto}?url=${encodeURIComponent(
          url
        )}&token=${encodeURIComponent(setToken)}`;
      } else {
        location.href = `${goto}?url=${encodeURIComponent(
          url
        )}&token=${encodeURIComponent(setToken)}`;
      }
    },
  },
};
</script>

<style>
#rattach ul li{
    padding: 0 1.25rem;
    overflow: hidden;
}
#rattach ul li:last-child {
    margin-bottom: 0.93rem;
}
#rattach ul li > div {
    display: block !important;
    width: 100% !important;
    padding: 0 !important;
    border:0 !important;
}
#rattach ul li div{
    display: block;
    font-size: 0.93rem;
    color: #333;
    line-height: 3.06rem;
    vertical-align:top;
}
#rattach ul li div.vip_sib {
    float: left;
    width: calc(100% - 3.75rem) !important;
}
#rattach ul li div > span {
    display: inline-block;
    border: 0.06rem solid #f2f2f2;
    width: 3.75rem;
    height: 3.75rem;
    position: relative;
    vertical-align: top;
    padding-left: 0 !important;
}
#rattach ul li > div div {
    display: inline-block;
    border: 0.06rem solid #f2f2f2;
    position: relative;
    vertical-align: top;
    padding: 0.81rem 3.12rem 0 0.62rem;
    width: calc(100% - 3.75rem);
    margin-left: -0.06rem;
    height: 3.75rem;
}
#rattach ul li > span{display:none !important;}
#rattach ul li > span.vip {
    float: left !important;
    display:inline-block !important;
    width: 3.75rem;
    height: 3.75rem;
    background: url(/mobile/img/attach_download.svg)center no-repeat;
    border: 0.06rem solid #f2f2f2;
    border-left: 0;
    background-size: 1.125rem 1.125rem;
    margin-left: -0.06rem;
    cursor: pointer;
}
#rattach > span {
    display: inline-block;
    width: 5.43rem;
    font-size: 0.87rem;
    color: #666;
    padding-left: 1.25rem;
    line-height: 3.06rem;
    vertical-align: top;
    position: relative;
    padding-right: 1.25rem;
    width: 100%;
}
</style>